export default __webpack_public_path__ + "static/project-slide-7-992-765-c1e5d0d3167c1228e9f8b84d900d14bd.webp";